import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getDepartamento, cadastrarDepartamento, alterarDepartamento, excluirDepartamento } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var DepartamentosEditar = function () {
    var services = {
        getItem: getDepartamento,
        cadastrarItem: cadastrarDepartamento,
        alterarItem: alterarDepartamento,
        excluirItem: excluirDepartamento,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.DEPARTAMENTOS, paginaPermissao: FUNCIONALIDADES.DEPARTAMENTOS, rota: ROUTES.DEPARTAMENTOS, services: services });
};
export default DepartamentosEditar;
